
export interface ApiConfig {
  restApiUrl: string;
  additionalHeaders?: Record<string, string>;
}

export const API_CONFIG: ApiConfig = {
  restApiUrl: process.env.REACT_APP_REST_API_URL || 'http://localhost:5001/nonograms-225103/us-central1/api',
  additionalHeaders:
    process.env.NODE_ENV === 'development'
      ? {
          'X-Mobile-App': 'you-wish-this-was-a-mobile-app',
        }
      : {},
};
